<script>
  import {format, isAfter, isBefore} from 'date-fns';
  import Duracion from "../../../UI/Duracion.svelte";
  import Boton from "../../../UI/Boton.svelte";
  import Advertencia from "../../../UI/Advertencia.svelte";
  import {url} from '@sveltech/routify';
  import {nombreCompleto} from '../../../../Modelos/Trabajador';

  import {horasTrabajadas} from '../../../../Modelos/Trabajador';
  import Icono from "../../../UI/Icono.svelte";
  import Diferencia from "../../../UI/Diferencia.svelte";
  import Horas from "../../../Marcajes/Horas.svelte";
  import Incidencias from "../../../Marcajes/Incidencias.svelte";

  export let marcaje;
  export let fecha;
  export let tipo;
  export let trabajador = null;

  let trabajado, previsto, diferencia, entradas, salidas, incorrecta, horas, aviso, tiposRepetidos;

  const ahora = new Date();

  let futuro = isAfter(fecha, ahora);

  $: {
    previsto = tipo.duracion || 0;

    if (marcaje) {
      horas = marcaje.horas;
      const t = horas.reduce((acc, hora) => acc + (hora.motivo.tipo === 'Actividad' ? '1' : '0'), '');
      tiposRepetidos = t.indexOf('11') >= 0 || t.indexOf('00') > 0;

      trabajado = horasTrabajadas(marcaje.horas);
      diferencia = trabajado - previsto;
      entradas = horas.filter(x => x.motivo.tipo === 'Actividad').length;
      salidas = horas.filter(x => x.motivo.tipo === 'Ausencia').length;
      incorrecta = tiposRepetidos;
      aviso = horas.filter(x => x.observaciones).length;
    } else {
      trabajado = entradas = salidas = 0;
      incorrecta = false;
      horas = [];
    }
  }
</script>

<style>
    tr {
        --color-linea: var(--naranja-clarito);
        font-family: var(--familia-monoespaciada);
    }

    td {
        vertical-align: middle;
    }

    .sin-datos {
        background: var(--naranja-clarito);
        --color-linea: #fff;
    }

    .fecha {
        white-space: nowrap;
        display: flex;
        align-items: center;
        --color-icono: red;
    }

    .incorrecta {
        font-weight: bold;
    }

    .marcaje {
        margin-right: .5em;
    }
</style>

<tr class:sin-datos={futuro || !previsto} class:incorrecta>
    <td>
        <div class="fecha">
            {format(fecha, 'dd/MM/yyyy')}
            {#if incorrecta}
                <Advertencia>Día con errores</Advertencia>
            {/if}
        </div>
    </td>
    {#if trabajador}
        <td class="trabajador">
            {nombreCompleto(trabajador)}
        </td>
    {/if}
    <td>
        {#if !previsto}
            {tipo.nombre}
        {:else }
            {#if aviso}
                <Icono tamano="mediano" svg="hand-paper.svg"/>
            {/if}
            {#each horas as marcaje}
                <Horas {marcaje}/>
            {/each}
            {#if marcaje && marcaje.incidencias.length}
                <br>
                Incidencias: <Incidencias {marcaje} />
            {/if}
        {/if}
    </td>

    {#if !tipo.duracion}
        <td colspan="4"></td>
    {:else}
        <td>
            <Duracion minutos={previsto}/>
        </td>
        {#if futuro}
            <td colspan="3"></td>
        {:else}
            <td>
                <Duracion minutos={marcaje ? marcaje.tiempoTotal : 0}/>
            </td>
            <td>
                <Diferencia {previsto} trabajado="{marcaje ? marcaje.tiempoTotal : 0}"/>
            </td>
            <td>
                <Boton tipo="ok" icono="keyboard_arrow_right"
                       href="{$url(`../marcajes/${format(fecha, 'dd-MM-yyyy')}`)}">Ver&nbsp;detalles
                </Boton>
            </td>
        {/if}
    {/if}
</tr>